import { ChangeDetectionStrategy, Component, HostBinding, Input } from "@angular/core";
import * as FlatModels from "@medsurf/flat-models";
import * as FlatFacades from "@medsurf/flat-facades";

@Component({
    selector: 'medsurf-slide-edit-header',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './edit-header.component.html',
    styleUrls: ['./edit-header.component.scss'],
    standalone: false
})
export class EditHeaderComponent {
  @Input() icon: string;
  @Input() label: string;
  @Input() type: string;

  @HostBinding('class') classAttribute = 'mt-3 ml-3 mr-3';
  
  readonly FlatModels = FlatModels;
  
  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
  }
  
  hideEditPanel() {
    this.slideAuthorFacade.requestHideEditPanel().subscribe({
      error: (result) => this.alertControlFacade.requestAddError(result),
    });
  }
}
